import firebaseApp from "../services/firebase";
import {useInfiniteQuery} from "react-query";
import {useParams} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {firebaseUidState} from "../state/firebaseState";
import peopleState from "../state/peopleState";
import queryClient from "../services/queryClient";
import useUser from "./useUser";
import firebase from 'firebase/app';
import 'firebase/database';

const useLoadPeople = () => {
  const { timing } = useParams();
  const firebaseUid = useRecoilValue(firebaseUidState);
  const setPeople = useSetRecoilState(peopleState);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if(!timing || !firebaseUid) {
      return;
    }

    const ref = firebaseApp.database()
    .ref('room-users')
    .child(timing);

    setIsLoading(true);

    ref.once('value', () => setIsLoading(false));

    ref.on('child_added', (item) => {
      setPeople(old => {
        const sessions = item.val();
        const sessionIndex = Object.keys(sessions).reverse().find(i => true);
        return [
          {
            ...(sessions[sessionIndex]),
            id: item.key,
          },
          ...old,
        ];
      })
    });

    ref.on('child_removed', (item) => {
      setPeople(old => {
        return old.filter(i => i.id !== item.key);
      });
    });

    ref.on('child_changed', (item) => {
      setPeople(old => {
        const oldClone = [...old];
        const index = oldClone.findIndex(i => i.id === item.key);

        const sessions = item.val();
        const sessionIndex = Object.keys(sessions).reverse().find(i => true);
        oldClone[index] = {
          ...(sessions[sessionIndex]),
          id: item.key,
        };

        return oldClone;
      })
    });


    return () => {
      setPeople([]);
    };
  }, [timing, firebaseUid]);

  return {
    isLoading,
  };
}

export default useLoadPeople;
